
















































































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import fidelitycard from '@/store/modules/fidelitycard';
import store from '@/store';
import Modal from '@/components/UI/Modal.vue';
import ui from '@/store/modules/ui';
import IconTrash from '@/components/SvgIcons/IconTrash.vue';
import IconStar from '@/components/SvgIcons/IconStar.vue';
import IconBagSmile from '@/components/SvgIcons/IconBagSmile.vue';
import cart from '@/store/modules/cart';

@Component({
  components: {
    Modal,
    IconTrash,
    IconStar,
    IconBagSmile,
  },
})
export default class GlamCardUse extends Vue {
  private loading: boolean = false;
  private modalId = 'insertglamcard';
  private bonus: string = '';
  private applyError: string = '';

  get availableBonus(): number {
    return fidelitycard.fidelityCard.bonus;
  }

  get fidelityStatus() {
    return cart.cart.extension_attributes.fidelity_status;
  }

  get nextFidelityStatus() {
    return cart.cart.extension_attributes.next_fidelity_status;
  }

  get pointsToNextFidelityStatus() {
    return Vue.filter('currency')(cart.cart.extension_attributes.points_to_next_fidelity_status);
  }

  get formattedAvailableBonus(): any {
    return Vue.filter('currency')(this.availableBonus);
  }

  get formattedMaxUsable(): any {
    return Vue.filter('currency')(this.maxUsable);
  }

  get maxUsable(): number {
    return fidelitycard.fidelityCard.max_usable;
  }

  get validateUseBonus(): string {
    var data_type = store.state.options.fidelity.round ? "integer":  "decimal:2";
    return "required|" + data_type + "|min_value:0";
  }

  get isLoyalty2023(): boolean {
    return store.state.options.fidelity.is_loyalty_2020;
  }

  get senioritySteps(): boolean {
    return store.state.options.fidelity.seniority_steps;
  }

  get currentStatus(): boolean {
    return cart.cart.extension_attributes.fidelity_status;
  }

  get currentStatusIndex(): boolean {
    return store.state.options.fidelity.active_key + 1;
  }

  get currentStatusColor(): boolean {
    return store.state.options.fidelity.seniority_steps[store.state.options.fidelity.active_key].color;
  }

  get endDate(): string {
    let end_date = fidelitycard.fidelityCard.end_date;
    const year = end_date.slice(-4);

    if (year === '0001' || year === '') {
      const currentYear = new Date().getFullYear();
      end_date = '31-12-' + currentYear;
    }

    return end_date;
  }

  get applied(): number {
    return fidelitycard.fidelityCard.applied_bonus;
  }

  get isApplied(): boolean {
    return parseFloat(fidelitycard.fidelityCard.applied_bonus.toString()) > 0;
  }

  get isLoyalty_double_optin_using_point_disabled(): boolean {
    return fidelitycard.fidelityCard.loyalty_double_optin_using_point_disabled;
  }

  private toggleModal(direction: boolean) {
    if (direction && this.availableBonus <= 0) {
      return;
    }
    direction ? ui.openModal(this.modalId) : ui.closeModal(this.modalId);
    this.resetError();
  }

  private resetError() {
    this.$validator.reset();
    this.applyError = '';
  }

  private async useBonus(bonus: string) {
    this.applyError = '';
    const bonusAmt = parseFloat(bonus.toString().replace(',', '.'));
    if (bonusAmt !== 0) {
      const valid = await this.$validator.validate('bonus');
      if (!valid) {
        return;
      }
    }
    this.loading = true;
    try {
      const res = await fidelitycard.useBonus(bonusAmt);
      if (res > 0) {
        this.toggleModal(false);
        this.$toast.success(this.$t('glamcard-bonusapplied', { bonus: res }).toString());
      } else if (bonusAmt !== 0) {
        this.applyError = this.$t('Cannot apply glam card points').toString();
      }
    } catch (e) {
      this.applyError = this.$t('Cannot apply glam card points').toString();
    }
    this.loading = false;
  }
}
